import { take, call, race, delay, put } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import { saveChatStylesAfterDrag } from '../../actions/chat-drag';
import { CHAT_STATE } from '../../constants';
import { ROUTES } from '../../constants/routes';
import { setChatStatus } from '../actions/from-client-frontend';

import * as FromClientFEActions from '../actions/from-client-frontend';
import { CHAT_LAYOUT_DOM_ID, CHAT_ROOT_ELEMENT_DOM_ID } from '../../constants/dom-ids';
import { clearStore } from '../../actions';
import { closeChat } from '../../utils/chat-close';
import AppEvents from '../constants/events';
import { trigger } from '../events-manager';

export function* waitForChatRender({ onRendered }) {
  const isChatRendered = Boolean(document.getElementById(CHAT_LAYOUT_DOM_ID));

  if (isChatRendered) {
    yield call(onRendered);
  }

  const { rendered } = yield race({
    rendered: take(FromClientFEActions.CHAT_WINDOW_RENDERED),
    timeout: delay(5000)
  });

  if (rendered) {
    return yield call(onRendered);
  }
}

export function* closeChatWindowSaga() {
  yield put(setChatStatus(CHAT_STATE.IDLE));
  yield put(saveChatStylesAfterDrag({ left: null, top: null, width: null, height: null }));

  const chatElement = document.getElementById(CHAT_ROOT_ELEMENT_DOM_ID);

  if (!chatElement) {
    return;
  }

  yield put(clearStore());
  yield put(push(ROUTES.ROOT));
  closeChat(CHAT_ROOT_ELEMENT_DOM_ID);
  trigger(AppEvents.ON_AFTER_CHAT_CLOSE);
  return;
}
